import React, { FC, useState } from 'react';
import { Pagination } from '@material-ui/lab';
import { Box, Container, Grid, Theme, useMediaQuery } from '@material-ui/core';
import { ProjectCard } from 'components/atoms';
import { makeStyles } from '@material-ui/styles';
import { NewsPaginationItem } from 'components/structures/news';
import { NewsPostList, PostCollection } from 'services/news/types';
import { NEWS_PAGE_SIZE } from 'config/cms/endpoints';
import services from 'services';

interface NewsPageProps {
  listNews: Array<NewsPostList>;
  total: number;
  selectedPage: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(13, 0, 42),
  },
  spacing: {
    padding: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 2.5),
    },
  },
}));

const NewsPage: FC<NewsPageProps> = ({ listNews, total, selectedPage }) => {
  const classes = useStyles();
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const [newsPosts, setNewsPosts] = useState<Array<NewsPostList>>(listNews);
  const [page, setPage] = useState<number>(selectedPage);
  const totalPages = Math.ceil(total / NEWS_PAGE_SIZE);
  const { newsService } = services;

  const scrollToTop = () => {
    window.scrollTo({
      top: 250,
      behavior: 'smooth',
    });
  };

  const changePage = async (page: number) => {
    let response: PostCollection = { data: [], total: 0 };
    if (page > 0) {
      try {
        response = await newsService.getAllPosts(page, '');
        setPage(page);
        setNewsPosts(response.data);
        scrollToTop();
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <Box className={classes.root}>
      <Container>
        <Grid container>
          {newsPosts.map(({ publish_at, title, description, image, link }, index, array) => (
            <Grid item md={index === 0 && (array.length % 2) - 5 ? 12 : 6} xs={12} key={index} className={classes.spacing}>
              <ProjectCard
                subtitle={publish_at}
                title={title}
                text={description}
                image={image}
                width={1285}
                height={550}
                link={`/news/${link}`}
                isNewsBlog
              />
            </Grid>
          ))}
        </Grid>
        {totalPages > 1 && (
          <Box mt={isSmall ? 20 : 10}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(_, page) => changePage(page)}
              shape="rounded"
              boundaryCount={1}
              siblingCount={0}
              renderItem={(item) => <NewsPaginationItem {...item} />}
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default NewsPage;
